/* eslint-disable import/prefer-default-export */

import React from "react";
import ThemeProvider from "./src/components/common/theme-provider";
import PopupSubscription from "./src/components/common/popup-subscription";
import { NewsletterProvider } from "./src/components/common/newsletter/context";

import { PreviewStoreProvider } from "gatsby-source-prismic";

// You can delete this file if you're not using it
export function wrapPageElement({ element }) {
  return (
    <ThemeProvider>
      {element}
    </ThemeProvider>
  );
}

async function newsletterSubscribe(email) {
  const data = {
    // u: "6539965b0dedaf360083cfff5",
    // id: "d5bc80279c",
    u:"6539965b0dedaf360083cfff5",
    id:"d5bc80279",
    f_id:"00f721eaf0",   
    EMAIL: email,
  };
  const urlEncoded = new URLSearchParams(data);
  return await window.fetch(
    "https://xaga.us13.list-manage.com/subscribe/post",
    {
      body: urlEncoded,
      method: "POST",
      mode: "no-cors",
    }
  );
}

async function newsletterSubscribeNew(email) {
  try {
    const response = await window.fetch("https://v0-new-project-1wuezjcu9ii-vppn2l.vercel.app/api/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
      mode: "no-cors"
    });

    // Con el modo no-cors, no podemos leer la respuesta
    // Si llegamos aquí, asumimos que la petición fue exitosa
    return { success: true, message: "Thank you for subscribing!" };
  } catch (error) {
    console.error("Newsletter subscription error:", error);
    return { success: false, error: error.message };
  }
}

// Exponer la función al objeto window
if (typeof window !== 'undefined') {
  window.newsletterSubscribeNew = newsletterSubscribeNew;
}

export const wrapRootElement = ({ element }) => (
  <NewsletterProvider>
    <PreviewStoreProvider>
      {element}
      <PopupSubscription onSubmit={newsletterSubscribeNew} />
    </PreviewStoreProvider>
  </NewsletterProvider>
);
